import { z } from 'zod';

export const AddClassPayloadSchema = z.object({
    selector: z.string().optional(),
    cssSelectors: z.array(z.string().optional()).optional(),
    classNames: z.array(z.string()),
});
export const RemoveClassPayloadSchema = z.object({
    selector: z.string().optional(),
    cssSelectors: z.array(z.string().optional()).optional(),
    classNames: z.array(z.string()),
});
export const ToggleClassPayloadSchema = z.object({
    selector: z.string().optional(),
    cssSelectors: z.array(z.string().optional()).optional(),
    classNames: z.array(z.string()),
});

export type AddClassPayload = z.infer<typeof AddClassPayloadSchema>;
export type RemoveClassPayload = z.infer<typeof RemoveClassPayloadSchema>;
export type ToggleClassPayload = z.infer<typeof ToggleClassPayloadSchema>;
